import { Component, OnInit, ViewChild } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { interval, Observable } from 'rxjs';
import { GETROOMTYPE } from '../Shared/Model/GetRoomtype';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../Shared/Service/login_service';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import beautify from 'xml-beautifier';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  echotoken: any;
    totalrows: number;
    id: number;
    pmscode: String;
    processstatus: String;
    rateType: String;
    mealPlanCode: any;
        startdt: any;
        enddt: any;
        receivedXML:any;
        receivedDate: any;
        postedXML:any;
        postedDate: any;
        responseXML:any;
        responseDate: any;
}
@Component({
  selector: 'app-fxcrstochinvflowreport',
  templateUrl: './fxcrstochinvflowreport.component.html',
  styleUrls: ['./fxcrstochinvflowreport.component.css'],
  providers: [DashboarduiService,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class FxcrstochinvflowreportComponent implements OnInit {
  displayedColumns: string[] = ['rundate','roomtype', 'availqty', 'sts', 'crdt','FXXML', 'reqResFile','reqDT', 'resDT'];
  url: string;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  today = new Date();
  todayFuture = new Date();
  selectedRunDate: Date = this.today;
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  isProgressing: Boolean = false;
  errorMessage: string;
  errorMsgSubscription: boolean;
  displayContent: boolean;
   dropdownSettingsDept: IDropdownSettings = {};
   Userid: any = [];
   apiresult: any;
   hotellist: any = [];
   lstgetcmlist:any[];
   dropdownDeptData: any;
   ColumnHeader: boolean;
   hotellistChannel: any[];
   hotellistproperty: any;
   selectedDeptItems: any;
   searchBarFilter: boolean = false;
   searchText:any;
   public Pmscodevalue: any;
   addBtnDisabledFunc: boolean = true;
   selectedChannel: any;
   hotelSearchDataStatus: any;
   heartBeatData: any;
   productType: any;
   currentDateStore: any;
   storeHeartBeatValue: any;
   blinkOfflineHotel: boolean;
   totalcount: number;
   lstBooking: any[];
   searchValueData: any;
   filterProperty: any;
   idsProductList: idsProductList[] = [];
   excelFunction: boolean = false;
   dataSource: MatTableDataSource<idsProductList>
   romtype: any;
   PGF: any = "0";
   PGT: any = "50";
   SearchRoomTypeData:any;
   status: any = [] = [];
   XMLName: any;
   defaultData: any = [] = [];
   display: Boolean = false;
   pageSize = 50;
   pageIndex = 0;
    constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) { }
    dropdownSettings = {};
    futureOneYear:any = new Date();
    futureOneYearDate: any = new Date(this.futureOneYear.setDate(this.futureOneYear.getDate() + 365));
    public SourceBy: any;
    lstRoomlist: GETROOMTYPE[];
    lstInventoryCopy: any = [] = [];
    lstInventory: any = [] = [];
    // dataSource: any = [];
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true })
    hideSearchFilter(){
      this.searchText = '';
      this.searchBarFilter = false
    }
  ngOnInit() {
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.Pmscodevalue = localStorage.getItem("Select");
    console.log(this.Pmscodevalue)
    this.callIDSUsersProperties();
    this.SourceBy = "Pushdate";
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }
  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.fxcrstochinvgetproperties()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          // if (data.length < 1) {
          //   this.toastr.error('Property is not activated with Channel manager');
          // }
          //Remove duplicate data
          this.apiresult = data;
          console.log('Property 113 = ', data)
          
          this.hotellist = this.apiresult.filter((obj: { pmsname: any; }, pos: any, arr: any[]) => {
            return arr
              .map((mapObj: { pmsname: any; }) => (mapObj.pmsname))
              .indexOf(obj.pmsname) == pos;
          });
          this.lstgetcmlist = this.apiresult.filter((obj: { cmname: any; }, pos: any, arr: any[]) => {
            return arr
              .map((mapObj: { cmname: any; }) => (mapObj.cmname))
              .indexOf(obj.cmname) == pos;
          });
          this.dropdownDeptData = this.hotellist;
          this.hotellistChannel = this.lstgetcmlist;
          this.hotellistproperty = this.hotellist;
          this.ColumnHeader = true;
          this.isProgressing=false;
          //this.addBtnDisabledFunc = false;
        });
  }
  GetRoomTypeList()
    {
      console.log(this.Pmscodevalue)
      this.apiCallIdsService.fxcrstochinvreportgetroomtype(this.Pmscodevalue)
        .subscribe(
          data => {
            this.lstRoomlist = data;
            console.log('roomList =', data)
            for (let roomID of this.lstRoomlist) {
              console.log('roomID.id', roomID.id)
              if (roomID.id == 'ALL' || roomID.id == 'all' || roomID.id == 'All') {
                console.log('roomID.name', roomID.name)
                this.SearchRoomTypeData= roomID.name;
              }
            }
          }
        )
    }
  changePropertySearch() {
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.totalcount = 0
        this.Pmscodevalue = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.Pmscodevalue)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.GetRoomTypeList();
        this.displayContent = false
        this.addBtnDisabledFunc = false
       
        var result = this.apiresult.filter((obj: { pmscode: MatSelectChange; }) => obj.pmscode == this.Pmscodevalue);
        console.log('filter record = ', result);
        this.lstgetcmlist = result;
        this.selectedChannel = this.lstgetcmlist[0].cmcode;
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat
            // For blinking the record
            const today = new Date()
            console.log('Today Date = ', today);
            this.currentDateStore = today.toLocaleTimeString('it-IT')
            console.log('Today Date = ', this.currentDateStore);
            this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
            var start = this.storeHeartBeatValue.split(":");
            var end = this.currentDateStore.split(":");
            var startDate = new Date(0, 0, 0, start[0], start[1], 0);
            var endDate = new Date(0, 0, 0, end[0], end[1], 0);
            var diff = endDate.getTime() - startDate.getTime();
            var hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            var minutes = Math.floor(diff / 1000 / 60);
            // console.log('minutes difference',minutes)
            console.log('minutes difference', hours + ":" + minutes)
            if ((hours + ":" + minutes) > "0:30") {
              console.log('blinkOfflineHotel true')
              this.blinkOfflineHotel = true
            } else {
              console.log('blinkOfflineHotel false')
              this.blinkOfflineHotel = false
            }
          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.addBtnDisabledFunc = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }
  changeDateOption(data: MatSelectChange) {
    console.log("selected --->" + data);
    this.selectedDate = new Date();
  }
  GetCommonMethodForLog() {
    this.PGF = "0";
    this.PGT = "50";
    this.ReadFXCRSChannelFlowReport();
  }
  ReadFXCRSChannelFlowReport() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.apiCallIdsService.fxcrstochinvreportread(this.Pmscodevalue,this.selectedDate, this.SearchRoomTypeData,
       this.selectedChannel,this.selectedDate, this.selectedTOODate,this.PGF, this.PGT,this.searchValueData,this.SourceBy)
       .subscribe(
        data => {
          console.log('260 = ', data)
          if (data[0].totalCount >= 1) {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.totalcount = data[0].totalCount;
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          } else {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
        });
  }
     
  LoadXML(xmltype: any, token: any) {
    this.isProgressing = true;
    this.apiCallIdsService.fxcrstochinvreportgetxml(token, xmltype)
      .subscribe(data => {
        if (data.length < 1) {
          this.toastr.error('No data to load');
        }else{
          const xml = beautify(data[0].xmlData);
          console.log(xml);
          if(xmltype == 'FXXML'){
            this.XMLName = 'FXXML'
          }
          this.defaultData = xml;
          this.display = true;
          this.isProgressing = false;
        }
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }
      heartbeatFunction() {
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat
          });
      }
      closeModalDialog() {
        this.display = false; //set none css after close dialog
      }
      pageEvent(e:any) {
    
        var pageIndex = e.pageIndex;
        this.pageIndex = pageIndex;
        console.log('this.pageIndex',this.pageIndex)
        this.pageSize = e.pageSize
        console.log('Pagesize = '+ this.pageSize)
        this.PGF = this.pageSize * pageIndex + 1;
        this.PGT = this.PGF + e.pageSize - 1;
          this.ReadFXCRSChannelFlowReport();
      }
      clearCmcode() {
        // Assuming you have a variable or property storing the cmcode, reset it here
        this.selectedChannel = null; // Replace `cmcode` with the actual variable name if different
      }
      downloadFile(fileUrl: string) {
        // You can use the HttpClient to download the file
        // or use the window.open function to open the file in a new tab
        window.open(fileUrl, '_blank');
      }
}
